import * as types from './actionTypes'
import * as api from '../../../../common/api'

export const fetchContacts = id => ({
    types: [types.FETCH_CONTACTS_REQUEST, types.FETCH_CONTACTS_SUCCESS, types.FETCH_CONTACTS_FAILURE],
    apiCall: () => api.getContacts(id)
});

export const selectContact = idx => ({
    type: types.CONTACT_SELECTED,
    selectedIndex: idx
});
export const closeContact = () => ({
    type: types.CONTACT_CLOSED
});
export const shiftContactLeft = () => ({
    type: types.CONTACT_SHIFT_LEFT
});
export const shiftContactRight = () => ({
    type: types.CONTACT_SHIFT_RIGHT
});
export const togglePanel = (key) => ({
    type: types.TOGGLE_PANEL,
    activePanelId: key
});

export const toggleButton = (enabled) => ({
    type: types.TOGGLE_BUTTON,
    buttonEnabled: enabled
});

export const saveContact = (comment, customerId) => ({
    types: [types.SAVE_CONTACTS_REQUEST, types.SAVE_CONTACTS_SUCCESS, types.SAVE_CONTACTS_FAILURE],
    apiCall: () => api.saveContact(comment, customerId)
});